// stores/modalStore.js
import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useModalStore = defineStore('modal', () => {
  // modalType: 어떤 팝업을 열지 결정
  // 예: '', 'LOGIN', 'SIGNUP', 'RESET_PASSWORD', 'ALERT'
  const modalType = ref('');

  // 모달 열기 메서드
  function openModal(type) {
    modalType.value = type;
  }

  // 모달 닫기 메서드
  function closeModal() {
    modalType.value = '';
  }

  return {
    modalType,
    openModal,
    closeModal,
  };
});
